// Advisor-sent onboarding intake — "Additional Financial Asset & Money Questions"
// (verbatim from McKayla's 2026-06-18 PDF; ClickUp 86badfke7). This is the DEEPER
// advisor-sent quiz, separate from the free teaser quiz. Single-select per question.
//
// The two amount questions (net_worth, annual_income) are the asset-tier inputs that
// feed per-firm lead routing (86badfku3) — the backend parses the chosen range to a
// numeric floor. `key` is the stable field name stored in leads.onboarding (jsonb);
// keep the net_worth / annual_income option labels EXACTLY matching the backend
// parse_amount_bucket map in app/lib/advisor_routing.py.

export interface OnboardingQuestion {
  key: string;
  question: string;
  options: string[];
}

export const ONBOARDING_QUESTIONS: OnboardingQuestion[] = [
  {
    key: 'age_range',
    question: 'What is your age range?',
    options: ['18-30', '30-50', '50-65', '65+'],
  },
  {
    key: 'has_advisor',
    question: 'Do you have a financial advisor?',
    options: [
      'Yes, I love them',
      'Yes, but I am looking for a new one',
      'I use my parents',
      'I do it myself',
      "I don't have an advisor",
    ],
  },
  {
    key: 'has_investment_account',
    question: 'Do you have an investment account?',
    options: ['Yes', 'No', 'What is an investment account?', "I think so but I'm not sure"],
  },
  {
    key: 'has_401k',
    question: 'Do you have a 401K plan through your work?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'annual_income',
    question: 'What is your annual income range?',
    // Labels MUST match parse_amount_bucket in the backend.
    options: ['$0-$100,000', '$100,000 - $250,000', '$250,000 to $500,000', '$500,000-$1mm', '$1mm +'],
  },
  {
    key: 'net_worth',
    question: 'What is your net worth?',
    // Labels MUST match parse_amount_bucket in the backend.
    options: ['$0-$100,000', '$100,000 - $250,000', '$250,000 to $500,000', '$500,000-$1mm', '$1mm +'],
  },
  {
    key: 'owns_home',
    question: 'Do you own a home?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'has_will_or_trust',
    question: 'Do you have a will or a trust?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'has_cpa',
    question: 'Do you have a CPA or tax preparer?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'has_life_insurance',
    question: 'Do you have life insurance?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'risk_tolerance',
    question: 'What is your investment risk tolerance?',
    options: [
      'N/A',
      'Aggressive',
      'Moderate',
      'Conservative',
      "I don't believe in investing. I keep my money in CD's or under my mattress",
    ],
  },
  {
    key: 'knows_stock',
    question: 'Do you know what a stock is?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'knows_diversification',
    question: 'Do you know what diversification means?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'knows_compounding',
    question: 'Do you know what compounding interest is?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'knows_cd_money_market',
    question: 'Do you know what a CD, money market, or savings account are?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'reads_financial_news',
    question:
      'Do you read the news or watch videos to learn about financial markets and personal financial planning?',
    options: ['Yes', 'No', "I don't know"],
  },
  {
    key: 'wants_monthly_info',
    question: 'Would you like more information provided to you on a monthly basis?',
    options: ['Yes', 'No', "I don't know"],
  },
];
